import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IItemOrderMapping, IItemOrderMappingState } from "../types/item-order-mapping";

const initialState: IItemOrderMappingState = {
  itemOrderMappings: [],
  loading: false,
  error: null,
};

export const itemOrderMappingSlice = createSlice({
  name: "itemOrderMapping",
  initialState,
  reducers: {
    // Tüm eşleştirmeleri set et
    setItemOrderMappings: (state, action: PayloadAction<IItemOrderMapping[]>) => {
      state.itemOrderMappings = action.payload;
      state.error = null;
    },

    // Tek eşleştirme ekle
    addItemOrderMapping: (state, action: PayloadAction<IItemOrderMapping>) => {
      const existing = state.itemOrderMappings.find(
        mapping => mapping.itemId === action.payload.itemId
      );
      
      if (!existing) {
        state.itemOrderMappings.push(action.payload);
      } else {
        // Mevcut varsa güncelle
        existing.orderNumber = action.payload.orderNumber;
      }
      state.error = null;
    },

    // Mevcut eşleştirmeyi güncelle
    updateItemOrderMapping: (state, action: PayloadAction<IItemOrderMapping>) => {
      const index = state.itemOrderMappings.findIndex(
        mapping => mapping.itemId === action.payload.itemId
      );
      
      if (index !== -1) {
        state.itemOrderMappings[index] = action.payload;
      }
      state.error = null;
    },

    // Eşleştirmeyi sil
    removeItemOrderMapping: (state, action: PayloadAction<string>) => {
      state.itemOrderMappings = state.itemOrderMappings.filter(
        mapping => mapping.itemId !== action.payload
      );
      state.error = null;
    },

    // Tüm eşleştirmeleri temizle
    clearItemOrderMappings: (state) => {
      state.itemOrderMappings = [];
      state.error = null;
    },

    // Loading durumu
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    // Error durumu
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setItemOrderMappings,
  addItemOrderMapping,
  updateItemOrderMapping,
  removeItemOrderMapping,
  clearItemOrderMappings,
  setLoading,
  setError,
} = itemOrderMappingSlice.actions;

export default itemOrderMappingSlice.reducer; 